import Vue from 'vue';
const EventBus = new Vue();

function registerEventListener(event, key, listener) {
  return {
    methods: {
      [key]: listener
    },
    mounted() {
      EventBus.$on(event, this[key]);
    },
    beforeDestroy() {
      EventBus.$off(event, this[key]);
    },
    deactivated() {
      EventBus.$off(event, this[key]);
    }
  }
}

const emitEvents = {
  methods: {
    emit(event, content) { EventBus.$emit(event, content); }
  }
}

export { emitEvents, registerEventListener, EventBus };